// extracted by mini-css-extract-plugin
export default {"root":"SearchViewFull_root__YzJoG"};